// Tlačítko „?“ v hlavičce — nápověda (F12 12.5; prototyp H:322 a panel H:5410). Panel s návody se stahuje až při
// otevření (klávesa F1 nebo klik), ať hlavička netáhne návody do hlavního balíku. „Poslat připomínku k návodu“
// z panelu otevře drawer ⚑ Nahlásit jako námět se zdrojem `napoveda` a odkazem na návod. „Co je nového v aplikaci“
// pod nadpisem panelu otevře okno novinek i s přečtenými (novinky/CoJeNoveho.tsx › CoJeNovehoRucne, W28).
// Na dotykovém tabletu se spodní lištou je „?“ v nabídce pod iniciálami (W86) — hlavička pak drží stav otevření
// a tlačítko se tu nekreslí (`sTlacitkem`); F1 i panel fungují stejně.
import type { Ja } from '@ecoser/shared';
import { useEffect, useState } from 'react';
import { AKCE_PODAT } from '../api/hlaseni';
import { lina, NacitaniCasti } from '../komponenty/NacitaniCasti';
import { maAkci } from '../komponenty/prava';
import type { NapovedaClanek } from '../api/napoveda';
import type { PredlohaZavady } from './NahlasitZavada';

const NapovedaPanel = lina(() => import('../napoveda/NapovedaPanel').then((m) => m.NapovedaPanel));
const Nahlasit = lina(() => import('./NahlasitUraz').then((m) => m.Nahlasit));
// Okno novinek se stahuje až při otevření jako v Shellu (`CoJeNoveho`) — statický import by táhl všechny novinky
// do hlavního balíku (kontrola #761, N2).
const CoJeNovehoRucne = lina(() => import('../novinky/CoJeNoveho').then((m) => m.CoJeNovehoRucne));

interface Props {
  ja: Ja;
  /** Otevřený panel nápovědy — drží ho hlavička, aby šel otevřít i z nabídky uživatele. */
  otevreno: boolean;
  naOtevreno: (otevreno: boolean) => void;
  /** Kreslit „?“ v hlavičce (false na tabletu se spodní lištou — nápověda je v nabídce uživatele). */
  sTlacitkem?: boolean;
}

export function NapovedaTlacitko({
  ja,
  otevreno,
  naOtevreno: setOtevreno,
  sTlacitkem = true,
}: Props) {
  const [pripominka, setPripominka] = useState<PredlohaZavady | null>(null);
  const [novinky, setNovinky] = useState(false);

  // F1 = nápověda (jako v programech na PC); prohlížeč by jinak otevřel svou vlastní.
  useEffect(() => {
    const naKlavesu = (udalost: KeyboardEvent) => {
      if (udalost.key === 'F1' && !udalost.ctrlKey && !udalost.altKey && !udalost.metaKey) {
        udalost.preventDefault();
        setOtevreno(true);
      }
    };
    document.addEventListener('keydown', naKlavesu);
    return () => document.removeEventListener('keydown', naKlavesu);
  }, [setOtevreno]);

  const naPripominku = (clanek: NapovedaClanek) => {
    setOtevreno(false);
    setPripominka({
      napovedaClanekId: clanek.id,
      napovedaTitul: clanek.titul,
      kde: `Nápověda › ${clanek.titul}`,
    });
  };

  return (
    <>
      {sTlacitkem && (
        <button
          type="button"
          className="hlavicka__napoveda"
          title="Nápověda — návody podle procesů (F1)"
          aria-label="Nápověda"
          aria-haspopup="dialog"
          aria-expanded={otevreno}
          onClick={() => setOtevreno(true)}
          data-testid="napoveda"
        >
          <span aria-hidden="true">?</span>
        </button>
      )}
      {otevreno && (
        <NacitaniCasti>
          <NapovedaPanel
            naZavrit={() => setOtevreno(false)}
            naPripominku={naPripominku}
            smiPripominku={maAkci(ja.akce, AKCE_PODAT)}
            naCoJeNoveho={() => {
              setOtevreno(false);
              setNovinky(true);
            }}
          />
        </NacitaniCasti>
      )}
      {novinky && (
        <NacitaniCasti>
          <CoJeNovehoRucne ja={ja} naZavrit={() => setNovinky(false)} />
        </NacitaniCasti>
      )}
      {pripominka && (
        <NacitaniCasti>
          <Nahlasit
            ja={ja}
            vychoziRezim="namet"
            predloha={pripominka}
            naZavrit={() => setPripominka(null)}
          />
        </NacitaniCasti>
      )}
    </>
  );
}
